import {
  FormControl,
  FormControlLabel,
  InputAdornment,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Card,
  CardContent,
  Typography
} from '@mui/material';
import { useState } from 'react';
import { useValue } from '../../../context/ContextProvider';
import InfoField from './InfoField';

const AddDetails = () => {
  const {
    state: {
      details: { title, description, price },
    },
    dispatch,
  } = useValue();

  const [costType, setCostType] = useState(price ? 1 : 0);

  const handleCostTypeChange = (e) => {
    const costType = Number(e.target.value);
    setCostType(costType);
    if (costType === 0) {
      dispatch({ type: 'UPDATE_DETAILS', payload: { price: 0 } });
    } else {
      dispatch({ type: 'UPDATE_DETAILS', payload: { price: 15 } });
    }
  };

  const handlePriceChange = (e) => {
    dispatch({ type: 'UPDATE_DETAILS', payload: { price: e.target.value } });
  };

  return (
    <Stack
      sx={{
        alignItems: 'center',
        '& .MuiTextField-root': { width: '100%', maxWidth: 500, m: 1 },
      }}
    >
      <FormControl>
        <RadioGroup
          name="costType"
          value={costType}
          row
          onChange={handleCostTypeChange}
        >
          <FormControlLabel value={0} control={<Radio />} label="Negociabil" />
          <FormControlLabel value={1} control={<Radio />} label="Recompensa RON" />
          {Boolean(costType) && (
            <TextField
              sx={{ width: '7ch !important' }}
              variant="standard"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
              inputProps={{ type: 'number', min: 1, max: 99999 }}
              value={price}
              onChange={handlePriceChange}
              name="price"
            />
          )}
        </RadioGroup>
      </FormControl>
      <InfoField
        mainProps={{ name: 'title', label: 'Titlu', value: title }}
        minLength={5}
      />
      <InfoField
        mainProps={{
          name: 'description',
          label: 'Descriere',
          value: description,
        }}
        minLength={10}
        optionalProps={{ multiline: true, rows: 4 }}
      />
      {/* Aici am adăugat cardul exemplu de anunț */}
      <Card 
    variant="outlined" 
    style={{ 
        marginTop: '20px', 
        maxWidth: '500px', 
        border: '2px solid #1976d2',  // O culoare de albastru, pentru a evidenția cardul.
        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',  // Adaugă o umbră puțină pentru un efect de "lift".
    }}
>
    <CardContent>
        <Typography variant="overline" color="textSecondary">
            Exemplu de misiune
        </Typography>
        <Typography 
            variant="subtitle1" 
            style={{ 
                marginTop: '10px', 
                fontWeight: 'bold',  // Textul va fi mai gros.
                color: '#d32f2f'  // O nuanță de roșu, pentru a scoate în evidență titlul.
            }}
        >
            Titlu: Curatenie generala in curte
        </Typography>
        <Typography 
            variant="subtitle1" 
            style={{ 
                fontWeight: 'bold'  // Textul va fi mai gros.
            }}
        >
            Descriere:
        </Typography>
        <Typography variant="body2">
            Curatenie generala intr-o curte de aproximativ 200 m patrati. Munca de aproximativ 1 zi. Asigur 3 mese. 
            <br />
            Nr. de telefon : 0754.333.202
        </Typography>
    </CardContent>
</Card>
    </Stack>
  );
};

export default AddDetails;
